module.exports = {
  // JCRing成员页 
  JCRing_member: {
    index1: "Zdraví členů",
    index2: "Zdravotní skupiny",
    index3: "Členové",
    index4: "Přidat skupinu",
    index5: "Připojené skupiny",
    index6: "Nastavení upozornění",
    index7: "Nechte ty, kteří se starají o vaše zdraví, více se starat o vás na dálku a poskytovat včasnou péči",
    index8: "Ještě jste se nepřipojili k žádným skupinám",
    index9: "Centrum zpráv",
    index10: "Pozvánka k připojení přes / telefon / e-mail / QR kód / WeChat",
    
    addgroup1: "Název skupiny",
    addgroup2: "Typ skupiny",
    addgroup3: "Zadejte název skupiny",
    addgroup4: "Rodinná skupina",
    addgroup5: "Firemní skupina",
    addgroup6: "Jiná skupina",
    addgroup7: "Zdravotní skupina",
    addgroup8: "Školní skupina",
    addgroup9: "Potvrdit",
    addgroup10: "Zrušit",
    addgroup11: "Vytvořit nyní",
    addgroup12: "Název skupiny již existuje",

    memberlist1: "Seznam členů",
    memberlist2: "Má",
    memberlist3: "Výjimky",
    memberlist4: "Normální",
    memberlist5: "Přidat člena",
    memberlist6: "Rozpustit",
    memberlist7: "Žádní členové",
    memberlist8: "Načítání...",
    memberlist9: "Rozpustit tuto skupinu?",
    memberlist10: "Úspěšně rozpuštěno",
    memberlist11: "Úspěšně uloženo",
    memberlist12: "Upravit informace o skupině",
    memberlist13: "Rozpustit skupinu",
    memberlist14: "Přehled zdraví",
    memberlist15: "Normální položky",
    memberlist16: "Abnormální položky",
    memberlist17: "Klikněte pro zobrazení",
    memberlist18: "Žádná data za včera",
    memberlist19: "Včera",
    memberlist20: "Odesláno",
    memberlist21: "Pozvánky do skupiny odeslány, čekají na potvrzení",
 
    updatemember1: "Profilový obrázek",
    updatemember2: "Změnit",
    updatemember3: "Původní přezdívka",
    updatemember4: "Upravit přezdívku", 
    healthdata1: "zdravotní data",
    healthdata2: "zdravotní data",
    healthdata3: "Neděle",
    healthdata4: "Pondělí",
    healthdata5: "Úterý",
    healthdata6: "Středa",
    healthdata7: "Čtvrtek",
    healthdata8: "Pátek",
    healthdata9: "Sobota",
    healthdata10: "Srdční frekvence",
    healthdata11: "Variabilita srdeční frekvence",
    healthdata12: "Systolický tlak",
    healthdata13: "Diastolický tlak",
    healthdata14: "Variabilita teploty",
    healthdata15: "Saturace kyslíku v krvi",
    healthdata16: "Spánek",
    healthdata17: "Stres",
    healthdata18: "Cholesterol",
    healthdata19: "Triglyceridy",
    healthdata20: "Cholesterol s nízkou hustotou lipoproteinů",
    healthdata21: "Cholesterol s vysokou hustotou lipoproteinů",
    healthdata22: "Glykémie",
    healthdata23: "Před jídlem",
    healthdata24: "Po jídle",
    healthdata25: "Maximální příjem kyslíku",
    healthdata26: "Dech",
    healthdata27: "Kroky",
    healthdata28: "Krok",
    healthdata29: "Kalorie",
    healthdata30: "kcal",
    healthdata31: "Vzdálenost",
    healthdata32: "Kilometry",
    healthdata33: "Tempo",
    healthdata35: "Sekundy/kilometr",
    healthdata36: "Minuty",
    healthdata37: "Načítání zdravotních dat",
    healthdata38: "Data o cvičení",
    healthdata39: "Upozornění",
    healthdata40: "Neautorizováno",
    healthdata41: "Upravit informace o členovi",
    healthdata42: "Odstranit člena",
    healthdata43: "E-mail:",
    healthdata44: "Telefon:",
    healthdata45: "Odebrat tohoto člena?",
    healthdata46: "Budoucí data nelze zobrazit",
    healthdata47: "Dnes",

    addmember1: "Pozvat členy",
    addmember2: "Přidat účet člena",
    addmember4: "Pomocí 'účtů členů' můžete zobrazit zdravotní data členů a nastavit rozsahy upozornění pro lepší sledování jejich zdraví",
    addmember5: "Zjistit více",
    addmember6: "Členové zdravotní skupiny",
    addmember7: "Pozvat",
    addmember8: "Připojit se",
    addmember9: "Pozvat naskenováním QR kódu",
    addmember10: "Pozvat přes WeChat",
    addmember11: "Pozvat ke vstupu do skupiny naskenováním QR kódu",
    addmember12: "Pozvat ke vstupu do skupiny přes WeChat",
    addmember13: "Pozvat přes telefon/e-mail",
    addmember14: "Pozvat ke vstupu do skupiny přes telefon/e-mail",
    addmember15: "Pozvat členy ke vstupu, abyste mohli zobrazit jejich zdravotní stav",
    addmember16: "Odeslat pozvání",
    addmember17: "Odesláno",
    addmember18: "Čeká na potvrzení",
    addmember19: "Jsem členem",
    addmember20: "Sdílet nyní",
    addmember21: "Uložit obrázek",
    addmember22: "Odmítl jsem",
    addmember23: "Odešel jsem",
    addmember24: "Člen odešel",
    addmember25: "Člen odmítl",
    addmember26: "Člen se připojil",
    addmember27: "Jiné metody přidání",
    
    
    code1: "QR kód skupiny",
    code2: "Skupina pro správu zdraví",
    code3: "Tento QR kód je platný 5 minut. Prosím, použijte ho včas.",
  
    // invide1: "Pozvání do skupiny",
    // invide2: "Zdraví členů",
    // invide3: "Pozvání k připojení do skupiny...",
    // invide4: "Připojit se ke skupině",
    // invide5: "Pro vaše bezpečí dat se doporučuje před připojením zkontrolovat informace o skupině.",
    // invide6: "Po připojení ke skupině autorizujete sledovatele k zobrazení vašich zdravotních údajů.",
    
  
    sethealthdata1: "Nastavení zdravotních dat",
    sethealthdata2: "Potvrdit",
    sethealthdata3: "Nastavte prosím přezdívku",
    sethealthdata4: "Povolit vše",
    sethealthdata5: "Nastavit přezdívku",
    sethealthdata6: "Uložit",
    sethealthdata7: "Zadejte prosím",
    sethealthdata8: "Nahrajte prosím v obrázkovém formátu",
    sethealthdata9: "Nastavte prosím přezdívku a avatar",
    sethealthdata10: "Nastavte prosím avatar",
    sethealthdata11: "Délka přezdívky by měla být 1-8 znaků",
    
  
    setscope1: "Rozsah srdeční frekvence",
    setscope2: "Rozsah teploty",
    setscope3: "Rozsah spánku",
    setscope4: "Rozsah srdeční frekvence plodu",
    setscope5: "Glykemie před jídlem",
    setscope6: "Glykemie po jídle",
    setscope7: "Rozsah kyslíku v krvi",
    setscope8: "Kyselina močová u mužů",
    setscope9: "Kyselina močová u žen",
    setscope10: "Systolický tlak",
    setscope11: "Diastolický tlak",
    setscope12: "Horní mez",
    setscope13: "Dolní mez",
    setscope14: "Nastavení upozornění",
    setscope15: "Nastavení uloženo",
    setscope16: "Horní mez",
    setscope17: "Dolní mez",
    setscope18: "Upozornění",
 
    onload1: "Klikněte",
    onload2: "Připojit se ke skupině zdraví",
    onload3: "Otevřete v prohlížeči",
    onload4: "Rozuměl/a jsem",
    onload5: "Youhong zdraví, chytré zdraví každý den",
    onload6: "Stáhnout zdarma z App Store",
    onload7: "Stáhnout zdarma",
    onload8: "Odkaz vypršel",
    onload9: "QR kód vypršel",
    onload10: "Úspěšně připojeno",
 
    invide1: "Pozvání do skupiny",
    invide2: "Zdraví členů",
    invide3: "Pozvání k připojení do skupiny...",
    invide4: "Připojit se ke skupině",
    invide5: "Pro vaše bezpečí dat se doporučuje před připojením zkontrolovat informace o skupině.",
    invide6: "Po připojení ke skupině autorizujete sledovatele k zobrazení vašich zdravotních údajů.",
 
    guide1: "Po vstupu do zdravotního stavu členů je třeba nejprve vytvořit odpovídající typ skupiny.",
    guide2: "Po vytvoření skupiny vstupte do skupiny, kde můžete zobrazit přehled zdraví uživatelů a pozvat nové členy.",
    guide3: "Nové členy do skupiny můžete pozvat pomocí skenování QR kódu, WeChat, telefonního čísla/e-mailu. Po připojení nových členů do skupiny můžete sledovat jejich každodenní zdravotní aktualizace.",
    guide4: "Kliknutím na zobrazení přehledu zdraví můžete zobrazit zdravotní údaje členů a posoudit normální nebo abnormální stavy.",
    guide5: "Další",
    guide6: "Dokončit",
    guide7: "Překročení varovné hodnoty",
    
    invite1: "Pozvat pomocí telefonního čísla/e-mailu",
    invite2: "Zadejte účet",
    invite3: "Zadejte telefonní číslo",
    invite4: "Zadejte e-mail",
    invite5: "Zadejte platné telefonní číslo",
    invite6: "Zadejte platný e-mail",
    invite7: "Už je členem této skupiny",
    invite8: "Uživatel neexistuje",
    invite9: "Vyberte zemi nebo region",
    invite10: "Zadejte klíčová slova pro hledání",
    invite11: "Potvrdit uživatele",
    invite12: "Pozvat je",
    invite13: "Vyberte",
  },

  // AI H5页面
  JCRingAI: {
    index: "Ahoj,",
    index1: "Týdenní přehledy",
    index2: "Týden",
    index3: "Měsíc",
    index4: "Zdravotní index",
    index5: "Index spánku",
    index6: "Index vitality",
    index7: "Index rovnováhy",
    index8: "Den",
    index9: "Rok",
    index10: 'Týdenní přehledy',
    index11: 'Měsíční přehledy',
    index12: "Zde jsou vaše měsíční zdravotní přehledy.",

    sleep: 'Obnova spánku',
    sleep1: 'Trend spánkového indexu',
    sleep2: 'Trend spánkového indexu',
    sleep3: 'Spánkový index je indikátorem pro hodnocení vašeho spánkového zdraví, vypočítaný na základě různých metrik, jako je celková doba spánku, účinnost spánku, doba usínání, tepová frekvence během spánku, hladina kyslíku ve spánku a HRV atd.',
    sleep4: 'Váš spánkový index je',
    sleep5: 'Přehled spánku',
    sleep6: 'Průměrná doba spánku je',
    sleep7: 'Fáze spánku',
    sleep8: 'Průměrná délka trvání',
    sleep9: 'Průměrné %',

    sleep11: 'Dřímoty',
    sleep12: 'Probuzený',
    sleep13: 'REM',
    sleep14: 'Lehký spánek',
    sleep15: 'Hluboký spánek',
    sleep16: 'Zabírá % celého týdne',
    sleep17: 'Celková délka spánku je',
    sleep18: 'Průměrná účinnost spánku je',
    sleep19: '%, Průměrná doba usínání je',
    sleep20: 'min',
    sleep21: 'Přehled spánku',

    sleep22: 'Vylepšená data o spánku',
    sleep23: 'Index spánku',
    sleep24: 'Ve srovnání s minulým týdnem',
    sleep25: 'Měsíční průměrný index spánku je',
    sleep26: 'Délka spánku',
    sleep27: 'Doba usínání',
    sleep28: 'Měsíční průměrný čas usínání je',
    sleep29: 'Oblasti ke zlepšení',
    sleep30: 'Účinnost spánku',
    sleep31: 'Měsíční efektivita spánku je',
    sleep32: 'Jak zlepšit účinnost spánku?',
    sleep33: 'Měsíční přehled spánku',

    Expend: 'Aktivita',
    Expend1: 'Trend indexu aktivity',
    Expend2: 'Trend indexu aktivity',
    Expend3: 'Index aktivity je ukazatel pro hodnocení vašeho stavu cvičení, vypočítaný na základě různých metrik, jako jsou denní kroky, vzdálenost, kalorie a objem cvičení.',
    Expend4: 'Týdenní průměrný index aktivity je',
    Expend5: 'Přehled aktivity',
    Expend6: 'Průměrný počet kroků je',
    Expend7: ', průměrná vzdálenost je',
    Expend8: 'km, kalorie jsou',
    Expend9: 'kcal',
    Expend10: 'Typ/Datum',
    Expend11: 'Kroky',
    Expend12: 'Kcal',
    Expend13: 'Vzdálenost',
    Expend14: 'Máte 5 dní na splnění cíle kroků',
    Expend15: ', máte 5 dní na splnění kalorického cíle',
    Expend16: ', máte 5 dní na splnění cíle vzdálenosti',
    Expend17: 'Aktivitační přehled',
    Expend18: 'Index aktivity',
    Expend19: 'Měsíční průměrný index aktivity je',
    Expend20: 'Průměrný počet kroků',
    Expend21: 'Měsíční průměrný počet kroků je',
    Expend22: 'Průměrné kalorie',
    Expend23: 'Měsíční průměrný počet kalorií je',
    Expend24: 'kcal',
    Expend25: 'Průměrná vzdálenost',
    Expend26: 'Měsíční průměrná vzdálenost je',
    Expend27: 'km',
    Expend28: 'Jak zlepšit data o aktivitě?',
    Expend29: 'Přehled aktivit',

    Pressure: 'Rovnováha',
    Pressure1: 'Trend indexu rovnováhy',
    Pressure2: 'Trend indexu rovnováhy',
    Pressure3: 'Index rovnováhy je indikátor pro hodnocení vašeho stresového stavu, který se vypočítává na základě různých měřítek, jako je denní stres, HRV, reakce na stres a index zotavení.',
    Pressure4: 'Průměrný index vitality je',
    Pressure5: 'Index rovnováhy zůstává obecně stabilní, ale s výraznými kolísáními, které mohou být spojeny s vaším emočním stavem. Doporučuje se naučit se techniky zvládání stresu, jako je meditace a hluboké dýchání, k regulaci emocí a udržení fyzického a duševního zdraví.',
    Pressure6: 'Přehled rovnováhy',
    Pressure7: 'Průměrný stres je',
    Pressure8: 'Průměrná reakce na stres je',
    Pressure9: 'Průměrný index regenerace je',
    Pressure10: 'Stres',
    Pressure11: 'Reakce na stres',
    Pressure12: 'Index obnovy',
    Pressure13: 'Pohledy na rovnováhu',

    Pressure14: 'Vaše vylepšené údaje o rovnováze',
    Pressure15: 'Index rovnováhy',
    Pressure16: 'Měsíční reakce na stres je',
    Pressure17: 'Průměrný stres',
    Pressure18: 'Měsíční průměrný stres je',
    Pressure19: 'Jak zmírnit stres?',
    Pressure20: 'Přehled rovnováhy a regenerace?',

    Health: 'Kardiovaskulární zdraví',
    Health1: 'Vaše týdenní tendence srdečního tepu',
    Health2: 'Průměrný srdeční tep je',
    Health3: 'bpm',
    Health4: 'Vaše týdenní tendence hladiny kyslíku v krvi',
    Health5: 'Týdenní průměrný obsah kyslíku v krvi je',
    Health6: 'Vaše týdenní riziko cukrovky',
    Health7: 'Týdenní hodnocení rizika diabetu',
    Health8: 'Dny',
    Health9: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
 
    Health10: 'Vaše normální zdravotní údaje',
    Health11: 'Průměrný srdeční tep',
    Health12: 'Měsíční průměrný srdeční tep je',
    Health13: 'Průměrný SpO2',
    Health14: 'Měsíční průměrný SpO2 je',
    Health15: 'Vaše abnormální zdravotní údaje',
    Health16: 'Průměrná HRV',
    Health17: 'Měsíční průměrná HRV je',
    Health18: 'ms',
    Health19: 'Jak zlepšit HRV?',
        

   
 }
};



// WEBPACK FOOTER //
// ./src/lang/cs.js